export default __webpack_public_path__ + "static/0297-ea505a9e1c998fc3874032330e4466d9.png";